var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"condition-content"},[_c('compare-selector',{ref:"selector",attrs:{"value":_vm.currentValue,"valid":_vm.valid,"type":"GENDER","placeholder":_vm.$t('请选择性别')},on:{"change":_vm.onChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }